import { Box } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Checkboxes } from 'mui-rff';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/shared/components/Form/TextField';
import { Step } from '../../components/Step';

export const Step3 = () => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();

  return (
    <Step
      title={`${t('integrations.step')} 3`}
      subtitle={t('integrations.if you also want to record')}
      Icon={MonetizationOnIcon}
    >
      <Grid2 xs={12} sx={{ maxWidth: '300px' }} gap={3} container>
        <Grid2 xs={12}>
          <Box mt={-2} mb={2}>
            <Checkboxes
              name="recordTransactions"
              data={{ label: t('integrations.record transactions'), value: false }}
            />
          </Box>
        </Grid2>
        {values?.recordTransactions && (
          <Grid2 xs={12}>
            <TextField name="conceptCode" label={t('integrations.buk.concept code')} type="number" />
          </Grid2>
        )}
      </Grid2>
    </Step>
  );
};
